import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class HomologacionproductoModule { 

   id:number;
  idProductoRecibe:string;
  productValueRecibe:string;
  productRecibe:string;
  idProductoVende:string;
 productValueVende:string;
  productVende:string;


}
